/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const EyeClosed = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.7977 8L21.9461 8.86128C21.8721 8.97363 21.7214 9.19148 21.49 9.47542L22.5855 10.571L21.5248 11.6316L20.4619 10.5686C19.9983 10.9998 19.4256 11.4615 18.7381 11.8966L19.8021 13.338L18.5953 14.2289L17.4095 12.6225C16.6003 12.9996 15.677 13.3185 14.6344 13.5249L15.1212 15.3417L13.6723 15.7299L13.1369 13.7316C12.7703 13.7611 12.3914 13.7767 12 13.7767C11.6264 13.7767 11.2642 13.7625 10.9132 13.7355L10.3789 15.7298L8.92997 15.3416L9.41421 13.5344C8.35166 13.3284 7.41232 13.0054 6.59051 12.6225L5.40472 14.2289L4.19791 13.338L5.26197 11.8965C4.6026 11.4793 4.04884 11.0375 3.59563 10.6217L2.58581 11.6315L1.52515 10.5708L2.55994 9.53604C2.30019 9.22251 2.13314 8.9815 2.05398 8.86128L3.19935 8.00224L3.88385 8.77673C4.21425 9.15221 4.68034 9.61913 5.28961 10.0878C6.69913 11.172 8.88535 12.2767 12 12.2767C15.1147 12.2767 17.3009 11.172 18.7105 10.0878C19.3476 9.59767 19.8282 9.10946 20.1608 8.72574C20.4577 8.38305 20.664 8.1496 20.7977 8Z"
                        fill={color}
                    />
                </svg>
        );
    };
